/**
 * useBuddyGroups — list query for rodeo-scoped buddy groups.
 */

import { useQuery } from '@tanstack/react-query';
import { buddyGroupAdminKeys, fetchBuddyGroups } from '../buddy-group-service';

export function useBuddyGroups(rodeoId: string) {
  return useQuery({
    queryKey: buddyGroupAdminKeys.list(rodeoId),
    queryFn: () => fetchBuddyGroups(rodeoId),
    enabled: !!rodeoId,
  });
}
